module.exports = __webpack_public_path__ + "img/LR-hauptseite_Aromatherapie.b0603ada.png";